/**
 * @generated SignedSource<<2ef35ee6c40a450be7e1c310b470d704>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
import { FragmentRefs } from "relay-runtime";
export type ListItemRoles_roles$data = ReadonlyArray<{
  readonly employeeIds: ReadonlyArray<string>;
  readonly employees: ReadonlyArray<{
    readonly id: string;
    readonly isLinkedToViewer: boolean;
    readonly name: string;
    readonly workStatus: EmployeeWorkStatus;
    readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  }>;
  readonly id: string;
  readonly isLinkedToViewer: boolean;
  readonly name: string;
  readonly team: {
    readonly id: string;
  };
  readonly " $fragmentType": "ListItemRoles_roles";
}>;
export type ListItemRoles_roles$key = ReadonlyArray<{
  readonly " $data"?: ListItemRoles_roles$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemRoles_roles">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ListItemRoles_roles",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employeeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employees",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workStatus",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_employee"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};
})();

(node as any).hash = "33508efa4dd8fad1b8b5fc6c040f6bee";

export default node;
